// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { CardSummary } from '../../../types/card-summary'
import type { Module } from 'vuex'
import type { CardDetails } from '../../../types/card-details'
import { buildCardDetails } from '../../../types/card-details'
import type {CompanyCardsFilter} from '../../../types/company-cards-filter'
import {buildCompanyCardsFilter} from '../../../types/company-cards-filter'

export type CardState = {
  companyCardsForCurrentFilter: ?CardSummary[],
  totalNoCompanyCardsForCurrentFilter: number,
  companyCardsCurrentPageNumber: number,
  companyCardsPageSize: number,
  orderBy: ?string,
  orderDirection: ?string,
  filter: CompanyCardsFilter,
  cardDetails: CardDetails
}

export const DEFAULT_CURRENT_PAGE_NUMBER = 0

const initialState = (): CardState => {
  return {
    companyCardsForCurrentFilter: null,
    totalNoCompanyCardsForCurrentFilter: 0,
    companyCardsCurrentPageNumber: DEFAULT_CURRENT_PAGE_NUMBER,
    companyCardsPageSize: 10,
    orderBy: null,
    orderDirection: null,
    filter: buildCompanyCardsFilter(),
    cardDetails: buildCardDetails()
  }
}

export type CardModule = Module<CardState>

const companyModule: CardModule = {
  namespaced: true,
  state: initialState(),
  initialState: initialState(),
  getters,
  mutations,
  actions
}

export default companyModule



// WEBPACK FOOTER //
// ./src/store/modules/card/index.js